import React, { useState } from 'react';
import LandingPage from './components/auth/LandingPage';
import LoginPage from './components/auth/LoginPage';
import CursosExtensionPublic from './components/auth/CursosExtensionPublic';
import DashboardAdministrador from './components/administrador/DashboardAdministrador';
import DashboardEstudiante from './components/estudiante/DashboardEstudiante';
import DashboardKardex from './components/kardex/DashboardKardex';
import DashboardJefatura from './components/jefatura/DashboardJefatura';
import DashboardDireccion from './components/direccion/DashboardDireccion';
import RegistroPage from './components/auth/RegistroPage';
import RegistroPreadmisionPage from './components/auth/RegistroPreadmisionPage';
import RegistroCursosExtensionPage from './components/auth/RegistroCursosExtensionPage';
import VerificacionPage from './components/auth/VerificacionPage';
import RegistroExitosoPage from './components/auth/RegistroExitosoPage';
import RecuperarPage from './components/auth/RecuperarPage';
import ResetPasswordPage from './components/auth/ResetPasswordPage';
import DashboardDocente from './components/docente/DashboardDocente';
import DashboardPreadmisionCurso from './components/preadmision_curso/DashboardPreadmisionCurso';
import DashboardPreadmisionPrueba from './components/preadmision_prueba/DashboardPreadmisionPrueba';
import CuentaCreadaPage from './components/auth/CuentaCreadaPage';
import DashboardCursosExtension from './components/cursosExtension/DashboardCursosExtension';
import RectoradoDashboard from './components/rectorado/RectoradoDashboard';

function App() {
  const [currentPage, setCurrentPage] = useState('landing');
  const [pageProps, setPageProps] = useState({});
  const [userRole, setUserRole] = useState(null);
  const [authData, setAuthData] = useState(null);

  // Enhanced setCurrentPage to handle props
  const handleSetCurrentPage = (page, props = {}) => {
    setCurrentPage(page);
    setPageProps(props);
  };

  // Handle URL routing on mount
  React.useEffect(() => {
    const path = window.location.pathname;
    const hash = window.location.hash;
    const searchParams = new URLSearchParams(window.location.search || hash.split('?')[1]);

    const isResetPassword = path.includes('/reset-password') || hash.includes('/reset-password') || (searchParams.get('token') && searchParams.get('email'));
    
    if (isResetPassword) {
        // Enviar a la página de reset-password pasando los parámetros si es necesario
        handleSetCurrentPage('reset-password');
    } else if (path.includes('/verificar') || hash.includes('/verificar')) {
        handleSetCurrentPage('verificacion', {
          token: searchParams.get('token'),
          email: searchParams.get('email')
        });
    }
  }, []);

  const mapMenus = (menus) => {
    if (!Array.isArray(menus)) return [];
    return menus.map((m) => {
      const label = m.etiqueta || m.label || '';
      return {
        id: m.clave || m.id_menu || label || 'menu',
        id_menu: m.id_menu,  // Necesario para mapear padres
        label,
        short: (label || '').slice(0, 2).toUpperCase(),
        id_padre: m.id_padre || null,  // Incluir id_padre para menús jerárquicos
        orden: m.orden || 0
      };
    });
  };

  const handleLogout = () => {
    setCurrentPage('login');
    setPageProps({});
    setUserRole(null);
    setAuthData(null);
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'landing':
        return <LandingPage setCurrentPage={handleSetCurrentPage} />;

      case 'login':
        return <LoginPage setCurrentPage={handleSetCurrentPage} setUserRole={setUserRole} setAuthData={setAuthData} />;

      case 'cursos-extension-publicos':
        return <CursosExtensionPublic setCurrentPage={handleSetCurrentPage} />;

      case 'registro':
        return <RegistroPage setCurrentPage={handleSetCurrentPage} />;

      case 'registro-preadmision':
        return <RegistroPreadmisionPage setCurrentPage={handleSetCurrentPage} source={pageProps.source} />;

      case 'registro-cursos-extension':
        return <RegistroCursosExtensionPage
          setCurrentPage={handleSetCurrentPage}
          cursoId={pageProps.cursoId}
          cursoNombre={pageProps.cursoNombre}
          cursoCuotas={pageProps.cursoCuotas}
          cursoCosto={pageProps.cursoCosto}
          returnTo={pageProps.returnTo}
        />;

      case 'verificacion':
        return <VerificacionPage
          setCurrentPage={handleSetCurrentPage}
          email={pageProps.email}
          username={pageProps.username}
        />;

      case 'registro-exitoso':
        return <RegistroExitosoPage
          setCurrentPage={handleSetCurrentPage}
          username={pageProps.username}
          tipoRegistro={pageProps.tipo}
        />;

      case 'recuperar':
        return <RecuperarPage setCurrentPage={handleSetCurrentPage} />;

      case 'reset-password':
        return <ResetPasswordPage setCurrentPage={handleSetCurrentPage} />;

      case 'cuenta-creada':
        return <CuentaCreadaPage setCurrentPage={handleSetCurrentPage} />;

      case 'dashboard-administrador':
        return (
          <DashboardAdministrador
            onLogout={handleLogout}
            userName={authData?.user?.username || 'Usuario'}
            menuItems={mapMenus(authData?.menus)}
          />
        );

      case 'dashboard-estudiante':
        return (
          <DashboardEstudiante
            onLogout={handleLogout}
            userName={authData?.user?.username || 'Usuario'}
            menuItems={mapMenus(authData?.menus)}
          />
        );

      case 'dashboard-preadmision-curso':
        return (
          <DashboardPreadmisionCurso
            onLogout={handleLogout}
            userName={authData?.user?.username || 'Usuario'}
            menuItems={mapMenus(authData?.menus)}
          />
        );

      case 'dashboard-preadmision-prueba':
        return (
          <DashboardPreadmisionPrueba
            onLogout={handleLogout}
            userName={authData?.user?.username || 'Usuario'}
            menuItems={mapMenus(authData?.menus)}
          />
        );

      case 'dashboard-kardex':
        return (
          <DashboardKardex
            onLogout={handleLogout}
            userName={authData?.user?.username || 'Usuario'}
            menuItems={mapMenus(authData?.menus)}
            setCurrentPage={handleSetCurrentPage}
          />
        );

      case 'dashboard-docente':
        return (
          <DashboardDocente
            onLogout={handleLogout}
            userName={authData?.user?.username || 'Usuario'}
            menuItems={mapMenus(authData?.menus)}
          />
        );

      case 'dashboard-jefatura':
        return (
          <DashboardJefatura
            onLogout={handleLogout}
            userName={authData?.user?.username || 'Usuario'}
            menuItems={mapMenus(authData?.menus)}
          />
        );

      case 'dashboard-direccion':
        return (
          <DashboardDireccion
            onLogout={handleLogout}
            userName={authData?.user?.username || 'Usuario'}
            menuItems={mapMenus(authData?.menus)}
          />
        );

      case 'dashboard-cursos-extension':
        return (
          <DashboardCursosExtension
            onLogout={handleLogout}
            userName={authData?.user?.username || 'Usuario'}
          />
        );

      case 'dashboard-rectorado':
        return (
          <RectoradoDashboard
            onLogout={handleLogout}
            userName={authData?.user?.username || 'Usuario'}
            menuItems={mapMenus(authData?.menus)}
          />
        );
      default:
        return <LoginPage setCurrentPage={handleSetCurrentPage} setUserRole={setUserRole} setAuthData={setAuthData} />;
    }
  };

  return renderPage();
}

export default App;



